<mat-radio-group class="yes-no-group" [(ngModel)]="question.answer!.value" (change)="change()" aria-label="Select an option">
  <mat-radio-button class="yes-no-choice" [value]="true" i18n="@@Yes">{{"Yes"| translate}}</mat-radio-button>
  <mat-radio-button class="yes-no-choice" [value]="false" i18n="@@No">{{"No" | translate}}</mat-radio-button>
</mat-radio-group>
